module.exports = __webpack_public_path__ + "img/icon_bike_black.267d5b94.svg";